import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const PageRoot = lazy(() => import('@app/components/PageRoot'))
const EmailConfirmation = lazy(() => import('.'))

class EmailConfirmationWebComponent extends ReactWebComponent {
	override render() {
		return (
			<PageRoot>
				<EmailConfirmation />
			</PageRoot>
		)
	}
}

customElements.define('email-confirmation', EmailConfirmationWebComponent)
